import { createSelector } from 'reselect'
import RootState from '../types'
import State from './types'

const getWishlistState = (state: RootState): State => state.wishlist

export const getWishlistCount = createSelector<RootState, State, number | undefined>(
    getWishlistState,
    wishlist => wishlist.count,
)

export const getGuestFavoriteListings = createSelector<RootState, State, string[]>(
    getWishlistState,
    wishlist => wishlist.guestFavoriteListings,
)
